

export const index = 6;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/purchaseconfirmed/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/6.ht5j3Brw.js","_app/immutable/chunks/Z8InAVTp.js","_app/immutable/chunks/xihTtKlq.js"];
export const stylesheets = [];
export const fonts = [];
